export const BANNER_SKELETON_TEST_ID = {
  cardList1Container: 'cardList1Container',
  chip1Container: 'list1Container',
  chip2Container: 'list2Container',
  chip3Container: 'list3Container',
};